import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { MonitorTab, MonitorTabList } from '../monitors.const';

declare var $: any;

@Component({
  selector: 'monitors-channels',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.css'],
})
export class ChannelsComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Input() dataCall: any;
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public facebook = {
    waiting: 0,
    answer: 0,
  };
  public zalo = {
    waiting: 0,
    answer: 0,
  };
  public liveChat = {
    waiting: 0,
    answer: 0,
  };
  public email = {
    waiting: 0,
    answer: 0,
  };

  public channelChartOptions: any = {};
  public readonly tabList = MonitorTabList;
  public readonly MonitorTab = MonitorTab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    await this.initData();
  }

  ngAfterViewInit(): void {}

  async initData() {
    if (this.dataCall) {
      console.log('data call', this.dataCall);
      const {
        totalFacebookWaiting = 0,
        totalFacebookAnswer = 0,
        totalZaloWaiting = 0,
        totalZaloAnswer = 0,
        totalChatWaiting = 0,
        totalChatAnswer = 0,
        totalEmailWaiting = 0,
        totalEmailAnswer = 0,
      } = this.dataCall.analytic;
      this.facebook.waiting = totalFacebookWaiting;
      this.facebook.answer = totalFacebookAnswer;
      this.zalo.waiting = totalZaloWaiting;
      this.zalo.answer = totalZaloAnswer;
      this.liveChat.waiting = totalChatWaiting;
      this.liveChat.answer = totalChatAnswer;
      this.email.waiting = totalEmailWaiting;
      this.email.answer = totalEmailAnswer;
      let data = {
        facebook: this.facebook,
        zalo: this.zalo,
        liveChat: this.liveChat,
        email: this.email,
      };
      console.log('darta', data);
      const entries = _.toPairs(data);
      const sortedEntries = _.sortBy(entries, ([key, value]) => {
        return -_.sum(_.values(value));
      });
      data = _.fromPairs(sortedEntries);
      this.initChannelChart(data);
    }
  }

  initChannelChart(data) {
    let seriesWaiting = [];
    let seriesAnswer = [];
    let categories = [];
    Object.keys(data).forEach(key => {
      categories.push(key);
      seriesAnswer.push(data[key].answer);
      seriesWaiting.push(data[key].waiting);
    });
    this.channelChartOptions = {
      chart: {
        type: 'bar',
      },
      title: {
        enabled: false,
        text: '',
        align: 'left',
      },
      xAxis: {
        categories: categories,
        align: 'left',
        title: {
          text: null,
        },
        gridLineWidth: 1,
        lineWidth: 0,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
          align: 'high',
        },
        labels: {
          overflow: 'justify',
        },
        gridLineWidth: 0,
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        x: 0,
        y: 0,
      },
      tooltip: {
        valueSuffix: '',
      },
      plotOptions: {
        bar: {
          groupPadding: 0.1,
          pointWidth: 10,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Đang trả lời',
          data: seriesAnswer,
          color: 'rgba(68,143,236,0.7)',
        },
        {
          name: 'Đang chờ',
          data: seriesWaiting,
          color: 'rgba(236,226,44,0.7)',
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/channels/channels.component.ts